export default __webpack_public_path__ + "static/media/login-page-video-b.c5c12b41.mp4";